import { loadAndSaveDictionariesByName } from '@crm-framework/dictionaries';

import {
  loadDictionaryByTypeMethods,
  loadDictionaryMethods,
  loadTransactionSubTypesDictionaryByTypeMethods,
} from './api';
import {
  IDictionaries,
  IDictionariesByType,
  ITransactionSubTypesDictionariesByType,
} from './models';
import {
  DictionariesByType,
  DictionariesNameType,
  DictionariesWithApiNameType,
  TransactionSubTypesDictionariesByType,
} from './types';

/**
 * Load, save to state and return dictionaries by name generator.
 * This method returns the full entity model
 *
 * Use only in generator function!
 * To get the correct type use yield*.
 *
 * @generator
 * @param names
 * @param props
 * @param hardReloadDict
 */
export function* loadAndSaveDictionariesByNameCRM(
  names: DictionariesWithApiNameType[],
  props?: {
    [key in DictionariesNameType]?: any;
  },
  hardReloadDict?: (keyof IDictionaries)[]
) {
  return yield* loadAndSaveDictionariesByName<IDictionaries>(
    loadDictionaryMethods,
    names,
    props,
    hardReloadDict
  );
}

/**
 * Load, save to state and return dictionaries by type generator.
 * This method returns a model from pure dictionaries (id, name, ?order)
 *
 * Use only in generator function!
 * To get the correct type use yield*.
 *
 * @generator
 * @param names
 * @param props
 * @param hardReloadDict
 */
export function* loadAndSaveDictionariesByType(
  names: DictionariesByType[],
  props?: {
    [key in DictionariesByType]?: any;
  },
  hardReloadDict?: DictionariesByType[]
) {
  return yield* loadAndSaveDictionariesByName<IDictionariesByType>(
    loadDictionaryByTypeMethods,
    names,
    props,
    hardReloadDict
  );
}

export function* loadTransactionSubTypesDictionaryByType(
  names: TransactionSubTypesDictionariesByType[],
  props?: {
    [key in TransactionSubTypesDictionariesByType]?: any;
  },
  hardReloadDict?: TransactionSubTypesDictionariesByType[]
) {
  return yield* loadAndSaveDictionariesByName<ITransactionSubTypesDictionariesByType>(
    loadTransactionSubTypesDictionaryByTypeMethods,
    names,
    props,
    hardReloadDict
  );
}

// Conversion statuses
export const DICTIONARY_EMPTY_VALUE_ID = 0;
